export const IFRAME_MIN_HEIGHT = 100
export const IFRAME_MAX_HEIGHT = 5000
export const DEFAULT_IFRAME_HEIGHT = 300
